import { AppState } from "src/app/store/app.state";
import { Store } from "@ngrx/store";
import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { AuthService } from "./auth.service";
import { GeneralService } from "../services/general.service";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  userToken;
  origin = window.location.origin;

  constructor(
    private authService: AuthService,
    private router: Router,
    private gs: GeneralService,
  ) {
    this.userToken = this.gs.token;
    this.router.events.pipe(take(1)).subscribe((val) => {
      this.origin = window.location.origin;
    });

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.origin !== 'https://demo.notchcx.io' && this.origin !== 'http://localhost:1100') {
      if (this.authService.isUserLoggedIn()) {
        return true;
      }
      this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
      return false;
    } else {
      return true;
    }
  }
}
@Injectable({
  providedIn: "root"
})
export class UserActiveGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router) { }
  canActivate() {
    if (this.authService.isUserLoggedIn()) {
      this.router.navigate(['/dashboard'])
      return true;
    } else {
      // this.router.navigate(['/login'])
      return false;
    }
  }
}
